import UserUtils from './user-utils';
import {CHECKOUT_UPDATE_DATA} from 'checkout/checkout-actions';
import {
    USER_LOGIN,
    USER_LOGOUT,
    USER_UPDATE
} from './user-actions';

export const initialState = {
    isPending: false,
    data: {
        status: UserUtils.AUTH_STATE.LOGGED_OUT,
        id: null,
        email: null,
        isAdmin: false,
        isSeller: false,
        credit: 0,
        firstName: null,
        lastName: null,
        phoneNumber: null,
        licensePlates: [],
        creditCards: [],
        vehicles: [],
        favorites: [],
        referralToken: null,
    },
    error: null
};

export default function user(state = initialState, {type, payload}) {
    switch (type) {
        case `${USER_LOGIN}_PENDING`: {
            return {
                ...state,
                isPending: true,
                error: null
            };
        }

        case `${USER_LOGIN}_FULFILLED`: {
            return {
                ...state,
                isPending: false,
                data: UserUtils.normalize({data: payload.data.data})
            };
        }

        case `${USER_LOGIN}_REJECTED`: {
            return {
                ...state,
                error: 'Could not log in.'
            };
        }

        case `${USER_LOGOUT}_PENDING`: {
            return {
                ...state,
                isPending: true,
                error: null
            };
        }

        case `${USER_LOGOUT}_FULFILLED`: {
            return initialState;
        }

        case `${USER_LOGOUT}_REJECTED`: {
            return {
                ...state,
                error: 'Could not log out.'
            };
        }

        case USER_UPDATE: {
            return {
                ...state,
                data: {
                    ...state.data,
                    ...payload,
                }
            };
        }

        case CHECKOUT_UPDATE_DATA: {
            const {
                phone
            } = payload;

            return {
                ...state,
                data: {
                    ...state.data,
                    phoneNumber: (phone) ? phone : state.data.phoneNumber
                }
            };
        }

        default:
            return state;
    }
}
